var componentCls = '.ant-upload';
var genDraggerStyle = function genDraggerStyle(token) {
  var _ref, _ref2, _ref3, _ref4;
  return _ref4 = {}, _ref4[componentCls + "-wrapper"] = (_ref3 = {}, _ref3[componentCls + "-drag"] = (_ref2 = {
    '&:not(.ant-upload-disabled):hover': {
      backgroundColor: token.colorFillSecondary
    }
  }, _ref2["p" + componentCls + "-drag-icon"] = (_ref = {
    marginBottom: '8px'
  }, _ref['.anticon'] = {
    color: '#CACACC'
  }, _ref), _ref2["p" + componentCls + "-text"] = {
    // 文字14px
    fontSize: token.fontSize,
    color: token.colorTextSecondary
  }, _ref2), _ref3), _ref4;
};
var genListStyle = function genListStyle(token) {
  var _itemCls, _actionsCls, _ref5, _ref6, _ref7, _ref8;
  var colorPrimary = token.colorPrimary,
    iconCls = token.iconCls;
  var itemCls = componentCls + "-list-item";
  var actionsCls = itemCls + "-actions";
  var actionCls = itemCls + "-action";
  return _ref8 = {}, _ref8[componentCls + "-wrapper"] = (_ref7 = {}, _ref7[componentCls + "-list"] = (_ref6 = {}, _ref6[itemCls] = (_itemCls = {
    marginTop: '12px'
  }, _itemCls["&:hover"] = {
    // https://cooper.didichuxing.com/docs/document/2200512335156
    // hover态不带灰色背景
    backgroundColor: 'transparent'
  }, _itemCls[itemCls + "-name"] = {
    // 文字距离下方进度条4px
    marginBottom: '4px'
  }, _itemCls[itemCls + "-progress"] = {
    // ============== progress ============
    '.ant-progress': {
      '.ant-progress-outer': {
        '.ant-progress-inner': {
          '.ant-progress-bg': {
            backgroundColor: colorPrimary,
            height: '4px !important'
          }
        }
      }
    }
  }, _itemCls), _ref6[itemCls + "-error"] = (_ref5 = {}, _ref5[actionsCls] = (_actionsCls = {}, _actionsCls["" + iconCls] = {
    color: token.colorTextTertiary
  }, _actionsCls[iconCls + ":hover"] = {
    color: token.colorText
  }, _actionsCls), _ref5), _ref6[itemCls + ":hover " + actionCls] = {
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }, _ref6), _ref7), _ref8;
};
var genPictureStyle = function genPictureStyle(token) {
  var _itemCls2, _ref9, _ref0, _ref1;
  token.colorPrimary;
    token.colorPrimaryBg;
    token.iconCls;
    token.borderRadius;
  var listCls = '.ant-upload-list';
  var itemCls = ".ant-upload-list-item";
  return _ref1 = {}, _ref1[componentCls + "-wrapper"] = (_ref0 = {}, _ref0["" + listCls + listCls + "-picture-card"] = (_ref9 = {}, _ref9[itemCls] = (_itemCls2 = {
    padding: 0,
    overflow: 'hidden'
  }, _itemCls2['&.ant-upload-list-item-uploading'] = {
    '.ant-upload-list-item-thumbnail': {
      paddingTop: 16
    }
  }, _itemCls2[itemCls + "-progress"] = {
    bottom: 30,
    width: "calc(100% - " + token.paddingSM * 2 + "px)",
    paddingInlineStart: 16
  }, _itemCls2), _ref9), _ref0), _ref1;
};
var genPictureCardStyle = function genPictureCardStyle(token) {
  var _ref10, _ref11;
  var listCls = componentCls + "-list";
  return _ref11 = {}, _ref11[componentCls + "-wrapper" + componentCls + "-picture-card-wrapper"] = (_ref10 = {}, _ref10["" + listCls + listCls + "-picture-card"] = {
    '.ant-upload-list-item': {
      '&::before': {
        width: "100%",
        height: "100%"
      }
    },
    '.ant-upload-select': {
      color: '#CACACC',
      '&:hover': {
        backgroundColor: token.colorFillSecondary,
        borderColor: token.colorTextQuaternary
      }
    }
  }, _ref10), _ref11;
};

// ============================== Export ==============================
var uploadStyleFn = function uploadStyleFn(uploadToken) {
  return [genPictureStyle(uploadToken), genPictureCardStyle(uploadToken), genListStyle(uploadToken), genDraggerStyle(uploadToken)];
};

export { uploadStyleFn };
